interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizes = {
  sm: 'w-4 h-4 border-2',
  md: 'w-8 h-8 border-2',
  lg: 'w-12 h-12 border-4',
}

export default function LoadingSpinner({ size = 'md', className = '' }: LoadingSpinnerProps) {
  return (
    <div className="flex items-center justify-center min-h-[200px]" role="status" aria-label="Loading">
      <div
        className={`${sizes[size]} rounded-full border-gray-300 border-t-primary-600 animate-spin ${className}`}
      />
    </div>
  )
}
